import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { Alert } from 'antd'
import { useSelector } from 'react-redux'
import { optionsSelector } from 'app-redux/selectors'

function DemoWarning({ showIcon = true, style, ...props }) {
  const { demo } = useSelector(optionsSelector)

  if (demo !== 1) {
    return null
  }
  return (
    <Alert
      className="notification-demo hide-on-print alert-warning-highlight"
      style={{ borderRadius: 0, ...style }}
      message={
        <FormattedMessage
          id="setup.demo"
          values={{
            setup: (
              <Link to="/settings/setup">
                <strong>
                  <FormattedMessage id="setup.demo_link" />
                </strong>
              </Link>
            ),
          }}
        />
      }
      type="warning"
      showIcon={showIcon}
      {...props}
    />
  )
}

export default DemoWarning
